function moveItemsInArray<T>({
  items,
  starting,
  ending,
  itemIdMapper,
}: {
  items: T[];
  starting: string;
  ending: string;
  itemIdMapper?: (item: T) => string;
}): T[] {
  // if starting is ending, do nothing
  if (starting === ending) {
    return items;
  }

  /**
   *  if staring(s) is before ending(e) like this
   *    1 2 s 3 4 e 5 6
   *  then move to like this
   *    1 2 3 4 e s 5 6
   *
   *  if starting(s) is after ending(e) like this
   *    1 2 e 3 4 s 5 6
   *  then move to like this
   *    1 2 s e 3 4 5 6
   */
  const ensuredItemIdMapper = itemIdMapper ?? ((item: T) => item as string);
  const newItems = [...items];
  const startingIndex = newItems.findIndex((item) => ensuredItemIdMapper(item) === starting);
  const endingIndex = newItems.findIndex((item) => ensuredItemIdMapper(item) === ending);

  const [item] = newItems.splice(startingIndex, 1);
  newItems.splice(endingIndex, 0, item);
  return newItems;
}

export const DragAndDropFuncs = {
  moveItemsInArray,
};
